/* eslint-disable import/no-unresolved */
import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { truncate } from "lodash";

import ReasonPercentageIcon from 'images/orders/reason-percentage.svg';

import { formatMoney } from "../../../../../../util/numberUtils";

const OrderSummary = ({
  currencySymbol,
  validItems,
  orderSummary,
  currency,
  handleOrderDiscount,
  customTaxes,
  discountType,
  totalDiscount,
  discountReason
}) => {
  const { t } = useTranslation('Orders');

  return (
    <div className="tw-flex tw-flex-col tw-gap-2 tw-text-gray-950">
      <span className="tw-font-semibold tw-text-sm">{t('itemsBox.summary')}</span>
      <div className="tw-flex tw-flex-col tw-gap-1">
        <div className="tw-grid tw-grid-cols-3 tw-gap-2 tw-items-center">
          <span>{t('itemsBox.subtotal')}</span>
          <span className="tw-text-center tw-text-gray-700 tw-text-xs">
            {validItems.length}
            {' '}
            {validItems.length !== 1 ? t('itemsBox.items') : t('itemsBox.item')}
          </span>
          <span className="tw-text-right tw-px-4">
            {currencySymbol}
            {formatMoney(orderSummary.subtotal)}
            {' '}
            {currency}
          </span>
        </div>

        <div className="tw-grid tw-grid-cols-3 tw-gap-2 tw-items-center">
          <span
            className="tw-text-blue-500 tw-cursor-pointer tw-underline"
            onClick={handleOrderDiscount}
          >
            {discountType ? t('itemsBox.editDiscount') : t('itemsBox.addDiscount')}
          </span>
          <span className="tw-text-center tw-text-gray-700 tw-text-xs">
            {!discountType && ('-')}
            {Number(totalDiscount) > 0 && (
              <div className="tw-flex tw-items-center tw-justify-center">
                <img src={ReasonPercentageIcon} alt="" className="tw-w-5 tw-mr-[3px]" />
                {discountReason ? truncate(discountReason, { length: 40 }) : t('itemsBox.discount')}
                {' '}
                {`(-${orderSummary.total_discount}${currency})`}
              </div>
            )}
          </span>
          <span className="tw-text-right tw-px-4">
            {orderSummary.total_discount > 0 ? '-' : ''}
            {currencySymbol}
            {formatMoney(orderSummary.total_discount || 0)}
            {' '}
            {currency}
          </span>
        </div>

        {Number(orderSummary.total_discount) > 0 && (
          <div className="tw-flex tw-justify-between tw-items-center">
            <span>{t('itemsBox.subtotalWithDiscount')}</span>
            <span />
            <span className="tw-px-4">
              {currencySymbol}
              {formatMoney(orderSummary.subtotal_with_discount)}
              {' '}
              {currency}
            </span>
          </div>
        )}

        <div className="tw-grid tw-grid-cols-3 tw-gap-2 tw-items-center">
          <span>{t('itemsBox.tax')}</span>
          <span className="tw-text-center tw-text-gray-700 tw-text-xs">
            {customTaxes.length > 1 ? 'Personalizado' : `${customTaxes[0] || 0}%`}
          </span>
          <span className="text-right tw-px-4">
            {currencySymbol}
            {formatMoney(orderSummary.tax)}
            {' '}
            {currency}
          </span>
        </div>

        <div className="tw-flex tw-justify-between tw-items-center">
          <span>{t('itemsBox.shippingValue')}</span>
          <span />
          <span className="tw-px-4">
            {currencySymbol}
            {formatMoney(orderSummary?.shipping_value || 0)}
            {' '}
            {currency}
          </span>
        </div>

        <div className="tw-flex tw-justify-between tw-items-center">
          <span className="tw-font-semibold">{t('itemsBox.total')}</span>
          <span />
          <span className="tw-font-semibold tw-px-4">
            {currencySymbol}
            {formatMoney(orderSummary.total)}
            {' '}
            {currency}
          </span>
        </div>
      </div>
    </div>
  );
};

export default memo(OrderSummary);
